module.exports = __webpack_public_path__ + "img/angular.01bf5374.svg";